import React, { useEffect, useState } from "react";
import "../css/Add_service_popup.css";

function Add_service_popup(props) {

    const { arrayOfServiceListDropDown, idOfRow, sendServiceListitemClickToparent } = props;


    return (
        <div className="Add_service_popup-list-table-container ">
            <table className="Add_service_popup-service-list-table">
                <thead>
                    <tr>
                        <th><div>Service Code</div></th>
                        <th><div>Description</div></th>
                        {
                            // LOYALTY_PROGRAM
                            process.env.REACT_APP_ENABLE_LOYALTY_PROGRAM == "true" ?
                                <th><div>Points</div></th>
                                :
                                null
                        }
                        <th><div>Unit</div></th>
                        <th><div>Price</div></th>
                    </tr>
                </thead>
                <tbody>

                    {
                        arrayOfServiceListDropDown != null ?
                            arrayOfServiceListDropDown.map((item, index) => {
                                return (
                                    <tr onClick={() => sendServiceListitemClickToparent(idOfRow, item)}>
                                        <td><div>{item.Code}</div></td>
                                        <td><div>{item.Description}</div></td>
                                        { // LOYALTY_PROGRAM
                                            process.env.REACT_APP_ENABLE_LOYALTY_PROGRAM == "true" ?
                                                <td><div>{item.Points}</div></td>
                                                :
                                                null
                                        }
                                        <td><div>{item.unit}</div></td>
                                        <td><div>{item.price}</div></td>
                                    </tr>
                                )
                            })
                            :
                            null
                    }


                </tbody>
            </table>
        </div>
    )
}

export default Add_service_popup;